import NumberFormat from "react-number-format"
// import { lastMonth } from '../../../helpers/general'
import { useSelector } from "react-redux"

export const SectionTotals = ({ totals, amounts }) => {

    // const { simbolo, separacion_miles, separacion_decimales } = useSelector(state => state.general.detail)

    const {
        // local_moneda: moneda,
        local_simbolo: simbolo,
        local_separacion_miles: separacion_miles,
        local_separacion_decimales: separacion_decimales
    } = useSelector(state => state.general.info)

    return (
        <div className='m-2 md:m-0'>

            <div className="ms-1 mt-4">
                <div>
                    <h5>Resumen <label style={{ color: '#7d7a7d', fontSize: '16px' }}>(Incluye gastos directos e internos)</label></h5>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 p-dash-cards mt-2">

                <div className="d-flex flex-column p-3 justify-content-top align-items-left">
                    <span className='d-flex align-items-center'>
                        <label className='tabla-punto-ppto-d'></label>
                        <span className='ms-1'>Gasto presupuestado</span>
                    </span>
                    <span className="d-flex justify-content-between mt-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <NumberFormat
                            value={parseFloat(amounts?.total_gp || 0)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            prefix={`${simbolo || "S/"} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </span>
                </div>

                <div className="d-flex flex-column p-3 justify-content-top align-items-left">
                    <span className='d-flex align-items-center'>
                        <label className='tabla-punto-ppto'></label>
                        <span className='ms-1'>Gasto real</span>
                    </span>
                    <span className="d-flex justify-content-between mt-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <NumberFormat
                            value={parseFloat(amounts?.total_gr) || 0}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            prefix={`${simbolo || "S/"} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <NumberFormat
                            value={amounts?.percent_gr}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            decimalScale={2}
                            suffix="%"
                        />
                    </span>
                </div>

            </div>
        </div>
    )
}
